"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@emotion/core");

var react_1 = require("react");

exports.Icon = react_1.forwardRef(function (_a, ref) {
  var pathDef = _a.pathDef,
      pathFill = _a.pathFill,
      pathStroke = _a.pathStroke,
      children = _a.children,
      other = __rest(_a, ["pathDef", "pathFill", "pathStroke", "children"]);

  var pathDefs = typeof pathDef === 'object' ? pathDef : typeof pathDef === 'string' ? [pathDef] : [];
  var pathFills = typeof pathFill === 'object' ? pathFill : typeof pathFill === 'string' ? [pathFill] : [];
  var pathStrokes = typeof pathStroke === 'object' ? pathStroke : typeof pathStroke === 'string' ? [pathStroke] : [];
  return core_1.jsx("svg", __assign({
    ref: ref,
    css: {
      color: 'inherit',
      display: 'inline-block',
      fill: pathFills.length ? 'none' : 'currentColor',
      flexShrink: 0,
      height: '24px',
      stroke: 'none',
      userSelect: 'none',
      width: '24px'
    },
    focusable: "false",
    viewBox: "0 0 24 24"
  }, other), pathDefs.map(function (p, i) {
    return core_1.jsx("path", {
      key: i,
      fill: pathFills.length > i ? pathFills[i] : pathFills.length ? pathFills[pathFills.length - 1] : 'inherit',
      stroke: pathStrokes.length > i ? pathStrokes[i] : pathStrokes.length ? pathStrokes[pathStrokes.length - 1] : 'inherit',
      d: p
    });
  }), children);
});